import { computed, type MaybeRefOrGetter, type Ref, toRaw, toRef, toValue } from 'vue'
import type { Contract } from '../../Types/contract'
import type { ContractRestructuring } from '../../Types/restructuring'

export default function useContract(contract: MaybeRefOrGetter<Contract | null> = null) {
  const contractRef: Ref<Contract | null> = toRef(contract)

  const restructurings = computed<ContractRestructuring[]>(() => {
    if (null === contractRef.value) {
      return []
    }

    const restructurings = []
    if (contractRef.value.finance.restructuring) {
      restructurings.push(contractRef.value.finance.restructuring)
    }

    return restructurings.concat(contractRef.value.restructurings ?? [])
  })

  const isPartOfRestructuring = computed<boolean>(() => {
    return restructurings.value.length > 0
  })

  function unblock(): void {
    if (null === contractRef.value) {
      return
    }

    contractRef.value.blockedAt = null
  }

  return {
    // Ref
    contract: contractRef,
    // Computed
    isPartOfRestructuring,
    restructurings,
    // Methods
    unblock,
  }
}
